var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgCheckmarkCircleGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "161px",
    height: "161px",
    viewBox: "103 127 161 161",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1459517856_Complete_Symbol",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(103.000000, 127.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Complete_x5F_Symbol_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Complete_x5F_Symbol"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "BG",
    fill: "#19D873",
    cx: 80,
    cy: 80,
    r: 80
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Done_x5F_Symbol",
    fill: "#FFFFFF",
    points: "74 92.5 74 92.5 74 92.5 54.5 73 44 83.5 74 113.5 124 63.5 113.5 53"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircleGreen);
export default __webpack_public_path__ + "static/media/checkmark-circle-green.088121845194bfc7db02c6b84b61f0fd.svg";
export { ForwardRef as ReactComponent };